import React from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Bundles from './components/Bundles';
import Features from './components/Features';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import Impressum from './components/Impressum';

function App() {
  // Simple routing based on URL path
  const currentPath = window.location.pathname;
  
  if (currentPath === '/datenschutz' || currentPath === '/datenschutz.html') {
    return <PrivacyPolicy />;
  }
  
  if (currentPath === '/impressum' || currentPath === '/impressum.html') {
    return <Impressum />;
  }

  return (
    <div className="min-h-screen animated-bg">
      <Header />
      <main>
        <Hero />
        <Features />
        <Bundles />
      </main>
      <Footer />
    </div>
  );
}

export default App;
